import { render, staticRenderFns } from "./chinaEuropeTrain.vue?vue&type=template&id=40473c53&"
import script from "./chinaEuropeTrain.vue?vue&type=script&lang=js&"
export * from "./chinaEuropeTrain.vue?vue&type=script&lang=js&"
import style0 from "./chinaEuropeTrain.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports